import React from "react";
import { Link } from "react-router-dom";

// Consent line shown on every "Create an account" screen. Links the words
// "Terms of Use" and "Privacy Policy" to that flow's themed Legal Center with
// the matching tab pre-selected (?tab=terms / ?tab=privacy). ctx/slug keep the
// legal page on-brand for firm-linked client portals.
export default function SignupConsent({ ctx = null, slug = null, className = "", textClassName = "text-white/45", linkStyle, prefix = "By creating an account, I agree to the", testId = "signup-consent" }) {
  const build = (tab) => {
    const p = new URLSearchParams();
    p.set("tab", tab);
    if (ctx) p.set("ctx", ctx);
    if (slug) p.set("slug", slug);
    return `/legal?${p.toString()}`;
  };
  const linkCls = "underline underline-offset-2 font-medium hover:opacity-80 transition-opacity";
  return (
    <p data-testid={testId} className={`text-[12px] leading-relaxed text-center ${textClassName} ${className}`}>
      {prefix}{" "}
      <Link to={build("terms")} target="_blank" rel="noopener noreferrer" data-testid="consent-terms-link" style={linkStyle} className={linkCls}>Terms of Use</Link>{" "}
      and{" "}
      <Link to={build("privacy")} target="_blank" rel="noopener noreferrer" data-testid="consent-privacy-link" style={linkStyle} className={linkCls}>Privacy Policy</Link>.
    </p>
  );
}
